<div class="page">
  <div class="page__container">
    <h1 class="page__title h2 mb-5">{{ 'user_management_title' | translate }}</h1>
    <wsb-atlas-button class="my-3" [label]="'user_new'" (click)="openModalEdit()">{{ 'user_new' | translate }}</wsb-atlas-button>
    <div class="my-5">
      <ng-template #modalEdit let-c="close" let-d="dismiss">
        <wsb-modal
          (primary)="modalEditForm()"
          cancelButtonEnable="true"
          [primaryDisabled]="inputPhone.phoneNumber.invalid || editForm.invalid"
          (dismiss)="d()"
          title="{{ (elementToEdit ? 'profiles_edit_modal' : 'user_new') | translate }}"
        >
          <div body>
            <form [formGroup]="editForm">
              <label for="email" translate>user_username</label>
              <input
                [readonly]="elementToEdit"
                type="text"
                id="email"
                formControlName="email"
                name="email"
                class="form-control  form-control--short"
              />
              <wsb-validation-error-msg [fc]="editForm.get('email')"></wsb-validation-error-msg>
              <wsb-validation-error-msg *ngIf="!elementToEdit" [fc]="editForm.get('userName')"></wsb-validation-error-msg>
              <label for="name" translate>user_name</label>
              <input type="text" id="name" formControlName="name" name="name" class="form-control  form-control--short" />
              <wsb-validation-error-msg [fc]="editForm.get('name')"></wsb-validation-error-msg>
              <label for="surname" translate>user_surname</label>
              <input type="text" id="surname" formControlName="surname" name="surname" class="form-control  form-control--short" />
              <wsb-validation-error-msg [fc]="editForm.get('surname')"></wsb-validation-error-msg>
              <label for="phone" translate>user_phone</label>
              <wsb-atlas-inputphone
                class="d-block"
                id="phone"
                name="phone"
                [cssClass]="'form-control'"
                #inputPhone
                [formControlName]="'phone'"
              ></wsb-atlas-inputphone>
              <wsb-validation-error-msg [fc]="inputPhone.phoneNumber"></wsb-validation-error-msg>
              <label for="role" translate>user_role</label>
              <select id="role" formControlName="role" class="form-control  form-select form-select-sm">
                <option *ngFor="let role of roles" [ngValue]="role.id">
                  {{ 'user_' + role.id | translate }}
                </option>
              </select>
              <wsb-validation-error-msg [fc]="editForm.get('role')"></wsb-validation-error-msg>
            </form>
          </div>
        </wsb-modal>
      </ng-template>
      <ng-template #modalDelete let-c="close" let-d="dismiss">
        <wsb-modal
          (primary)="modalDeleteForm()"
          (dismiss)="d()"
          cancelButtonEnable="true"
          title="{{ 'common_attention' | translate }}"
          text="{{ 'user_delete_prompt' | translate }}"
        ></wsb-modal>
      </ng-template>
      <wsb-atlas-grid
        #grid
        class="atlas-grid-simplest"
        class="mt-2"
        [loading]="tableLoading"
        [columnDefs]="tableColumnDefs"
        [rowData]="tableData"
        [options]="tableGridOptions"
        [components]="components"
      >
      </wsb-atlas-grid>
      <!--      [rowData]="tableData"-->
    </div>
  </div>
</div>
